"use strict"

import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  BrowserRouter,
  Router,
  RouterProvider,
} from "react-router-dom";
import $ from 'jquery';
import Popper from 'popper.js';
import App from './App';
import Index from './components/Index';
import About from './components/About';



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    
    <App/>
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

